"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FOOTER : STYLES --------------- ++++++++++ */


var _default = {
  footer: {
    // background: theme.color.supporting.light.swatch,
    background: "linear-gradient(to bottom, ".concat(_index.theme.color.supporting.light.swatch, " 0%,#ffffff 100%)"),
    borderTop: (0, _index.replacePXinStringWithEM)("1px solid ".concat(_index.theme.color.grey.medium.swatch)),
    // boxShadow: replacePXinStringWithEM(`0 -1px 0 0 ${theme.boxShadow.bar}`),
    color: _index.theme.color.dark.dark.contrast,
    height: (0, _index.pxToEm)(103),
    width: '100%',
    padding: (0, _index.replacePXinStringWithEM)("0px ".concat(_index.theme.spacing.sides)),
    position: 'relative',
    // layout
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    // animations
    opacity: '0',
    animationName: 'fadeInUp',
    animationDelay: '.1s',
    animationDuration: '.2s',
    animationFillMode: 'forwards',
    // ----- groups ----- //
    '& .name-info': {
      color: '#A4A4AD',
      textAlign: 'left'
    },
    '& .name-links': {
      color: _index.theme.color.supporting.dark.swatch,
      marginRight: function marginRight(props) {
        return props.marginRight;
      },
      '& a': {
        color: _index.theme.color.supporting.dark.swatch
      }
    }
  }
};
exports.default = _default;